import { useTranslation } from 'react-i18next'

import { supportedLanguages, type SupportedLanguage } from '../i18n'

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const active = i18n.resolvedLanguage

  return (
    <div className="lang" role="group" aria-label={t('nav.language')}>
      {Object.entries(supportedLanguages).map(([code, label]) => (
        <button
          key={code}
          type="button"
          className="lang__button"
          aria-pressed={active === code}
          onClick={() => void i18n.changeLanguage(code as SupportedLanguage)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
